/**
 * 기능 플래그 상수
 * 환경 변수를 통해 기능의 활성화/비활성화를 제어합니다.
 */

const JOBCMPT_API_URL = 'https://jobcmpt.hy-academy.com';
const isJobcmptApiUrl = process.env.REACT_APP_URL === JOBCMPT_API_URL;

/**
 * 프로젝트 참여자 목록 From 날짜 필터 활성화 여부
 * REACT_APP_URL이 JOBCMPT 운영 URL일 때만 활성화됩니다.
 */
export const SHOW_PROJECT_USERS_FROM_DATE_FILTER = isJobcmptApiUrl;

/**
 * add1(ID) 중복 표시 기능 활성화 여부
 * REACT_APP_URL이 JOBCMPT 운영 URL일 때만 활성화됩니다.
 * 기본값: false (비활성화)
 */
export const SHOW_ADD1_DUPLICATE = isJobcmptApiUrl;
